import axios from "axios";
import Swal from "sweetalert2";

// Same baseUrl aapke AppContext.js mein jo hai wahi yahan bhi rakhein
const baseUrl = "http://127.0.0.1:8000/api";
// Live par jate waqt is line se replace karein:
// const baseUrl = "https://smartagrirent.btsportfolio2026.com/backend/public/api";

/*
========================================================================
 ASAL MASLA (jo fix ho raha hai)
========================================================================
Pehle "getActivePanelConfig()" localStorage mein 4 alag flags
("LoggedInCustomer", "LoggedInRental", "LoggedInMechanic",
"LoggedInAdmin") ko ek FIXED tarteeb mein check karta tha — jo bhi
sab se pehle mil jaye, wahi panel maan liya jata tha.

Masla ye tha: agar isi browser mein kabhi doosre panel se bhi login
hua tha (jaise testing ke doraan), aur us ka flag kisi wajah se
localStorage mein reh gaya (jaise Super Admin ka logout button
"authToken" aur "LoggedInAdmin" clear hi nahi karta tha — wo bug
alag se fix kiya gaya hai), to token expire hone par refresh GALAT
panel ke liye ho jata tha. Us naye token ka "guard" mismatch ho jata
tha, aur har agli request "This request is forbidden" (403) deti
thi — bilkul jaisa Super Admin Notifications page par ho raha tha.

FIX: ab hum localStorage flags par bharosa nahi karte. Hum dekhte
hain ke abhi USER KIS URL PAR HAI (window.location.pathname). Ye
hamesha sahi panel batayega, chahe purane flags localStorage mein
reh bhi gaye hon.
========================================================================
*/

function getActivePanelConfig() {
    const path = window.location.pathname;

    if (path.startsWith("/rental-admin")) {
        return {
            refreshUrl: `${baseUrl}/rentaladmin/authentication/refresh`,
            loginRedirect: "/rental-admin/login",
            storageKeys: ["LoggedInRental", "rentalEmail", "rentalPassword"],
        };
    }
    if (path.startsWith("/mechanic-admin")) {
        return {
            refreshUrl: `${baseUrl}/mechanicadmin/authentication/refresh`,
            loginRedirect: "/mechanic-admin/login",
            storageKeys: ["LoggedInMechanic"],
        };
    }
    if (path.startsWith("/admin")) {
        return {
            refreshUrl: `${baseUrl}/superadmin/authentication/refresh`,
            loginRedirect: "/superadmin/login",
            storageKeys: ["LoggedInAdmin", "adminEmail", "adminPassword"],
        };
    }
    // In teeno mein se koi match na ho to customer (public/user) panel
    // maan lete hain — /user/..., /product/..., home page, waghera.
    return {
        refreshUrl: `${baseUrl}/customer/authentication/refresh`,
        loginRedirect: "/user/login",
        storageKeys: ["LoggedInCustomer", "userEmail", "userPassword"],
    };
}

let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(newToken) {
    refreshSubscribers.forEach((cb) => cb(newToken));
    refreshSubscribers = [];
}

function forceLogout(loginRedirect, storageKeys) {
    localStorage.removeItem("authToken");
    storageKeys?.forEach((key) => localStorage.removeItem(key));
    Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Please login again to continue.",
    }).then(() => {
        window.location.href = loginRedirect || "/";
    });
}

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        const isTokenExpired =
            error.response?.status === 401 &&
            error.response?.data?.message === "token_expired";

        if (isTokenExpired && !originalRequest._retry) {
            originalRequest._retry = true;
            const panel = getActivePanelConfig();

            if (!panel) {
                // Konsa panel active hai pata nahi chala, seedha logout
                localStorage.removeItem("authToken");
                window.location.href = "/";
                return Promise.reject(error);
            }

            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    const res = await axios.post(
                        panel.refreshUrl,
                        {},
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                            },
                        }
                    );
                    const newToken = res.data.token;
                    localStorage.setItem("authToken", newToken);
                    isRefreshing = false;
                    onRefreshed(newToken);
                } catch (refreshError) {
                    isRefreshing = false;
                    forceLogout(panel.loginRedirect, panel.storageKeys);
                    return Promise.reject(refreshError);
                }
            }

            return new Promise((resolve) => {
                refreshSubscribers.push((newToken) => {
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                    resolve(axios(originalRequest));
                });
            });
        }

        return Promise.reject(error);
    }
);